export class ValidationService {
  static getValidatorErrorMessage(code: string) {
    const config = {
      required: 'Required',
      invalidCreditCard: 'Is invalid credit card number',
      invalidEmailAddress: 'Invalid email address',
      invalidBirthday: 'Invalid birthday. Format: YYYY-MM-DD',
      invalidNumber: 'Invalid number',
      invalidPassword:
        'Invalid password. Password must be at least 6 characters long.',
    };
    return config[code];
  }

  static creditCardValidator(control) {
    // Visa, MasterCard, American Express, Diners Club, Discover, JCB
    const regex = new RegExp(
      [
        '^(?:4[0-9]{12}(?:[0-9]{3})?|5[1-5][0-9]{14}|6(?:011|5[0-9][0-9])[0-9]{12}|3[47]',
        '[0-9]{13}|3(?:0[0-5]|[68][0-9])[0-9]{11}|(?:2131|1800|35\\d{3})\\d{11})$',
      ].join('')
    );

    if (control.value.match(regex)) {
      return null;
    } else {
      return { invalidCreditCard: true };
    }
  }

  static emailValidator(control) {
    // RFC 2822 compliant regex

    const regex = new RegExp(
      [
        "[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*@(?:[a-z0-9]",
        '(?:[a-z0-9-]*[a-z0-9])?\\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?',
      ].join('')
    );

    if (control.value && control.value.match(regex)) {
      return null;
    } else {
      return { invalidEmailAddress: true };
    }
  }

  static birthdayValidator(control) {
    if (control.value && control.value.match(/^\d{4}-\d{2}-\d{2}$/)) {
      return null;
    } else {
      return { invalidBirthday: true };
    }
  }

  static numberValidator(control) {
    if (control.value && control.value.match(/^\d+$/)) {
      return null;
    } else {
      return { invalidNumber: true };
    }
  }

  static passwordValidator(control) {
    // {6,100}           - Assert password is between 6 and 100 characters
    // (?=.*[0-9])       - Assert a string has at least one number
    if (
      control.value &&
      control.value.length >= 6 &&
      control.value.length < 100
    ) {
      return null;
    } else {
      return { invalidPassword: true };
    }
  }

  static matchingPasswords(passwordKey: string, confirmPasswordKey: string) {
    return (group: any): { [key: string]: any } => {
      const password = group.controls[passwordKey];
      const confirmPassword = group.controls[confirmPasswordKey];

      if (password.value !== confirmPassword.value) {
        return {
          mismatchedPasswords: true,
        };
      }
    };
  }
}
